(function () {
  'use strict';
  angular.module('vcdms.vcscan')
    .component('scansorter', {
      restrict: 'E',
      bindings: {
        file: '=',
        parentsave: '&',
        clientmode: '<?',
        filemode: '@'
      },
      templateUrl: 'vcdms/scan/scansorter-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'Rlog', 'pdfDelegate', 'Config', '$scope', '$http', 'LogReminderHelper', '$cookies', 'ClientHelper',
        function ($log, Rlog, pdfDelegate, Config, $scope, $http, LogReminderHelper, $cookies, ClientHelper) {
          let vm = this;
          vm.save = save;
          vm.saveClient = saveClient;
          vm.getTags = getTags;
          vm.clearPatient = clearPatient;
          vm.clearClient = clearClient;
          vm.saveKeywords = saveKeywords;
          vm.assignCat = assignCat;
          vm.formDisabled = formDisabled;
          vm.formSignoffDisabled = formSignoffDisabled;
          vm.finish = finish;
          vm.finishSignoff = finishSignoff;
          vm.diagClientSave = diagClientSave;

          vm.addLog = addLog;
          vm.addReminder = addReminder;

          // Control PDF Viewer
          vm.nextPage = nextPage;
          vm.previousPage = previousPage;
          vm.rotatePage = rotatePage;
          vm.gotoPage = gotoPage;
          vm.zoomIn = zoomIn;
          vm.zoomOut = zoomOut;

          $scope.$watch(() => vm.file, function (newValue, oldValue, scope) {
            // $log.debug('file watch fired old, new: ', oldValue, newValue);
            if ((angular.isDefined(newValue) && angular.isUndefined(oldValue))
              || ((angular.isDefined(newValue) && angular.isDefined(oldValue)) && oldValue.fileid !== newValue.fileid)) {
              $log.debug('file watch fired, fileid changed: ', newValue.fileid);
              vm.docready = false;
              pdfDelegate.load('/routes/files/filereader/' + newValue.fileid).then(
                function () {
                  vm.docready = true;
                  vm.maxpc = pdfDelegate.getPageCount();
                  vm.currentpage = pdfDelegate.getCurrentPage();
                }
              );
              // get patient diagnoses

              if (angular.isDefined(vm.file.patientid)) {
                ClientHelper.find(vm.clientmode, vm.file.patientid).$then(function (client) {
                  vm.client = client;
                  if (angular.isUndefined(vm.client.deleteddiagnoses) || !angular.isArray(vm.client.deleteddiagnoses)) {
                    vm.client.deleteddiagnoses = [];
                    vm.client.$save();
                    $log.debug('initalised deleteddiagnoses to empty array');
                  }
                });
              }
            }
          }, true);


          vm.$onInit = function () {
            // retrieve customer document classifications
            Config.$find('dmsgencat').$then((dc) => {
              vm.dmsgencat = dc.dmsgencat;
            });
            Config.$find('dmspatientcat').$then((pc) => {
              vm.dmspatientcat = pc.dmspatientcat;
            });
            // get document pagecount
            vm.maxpc = pdfDelegate.$getByHandle('scans-pdf-container').getPageCount();
            vm.ready = true;


          };

          // catch late propagating clientmode changes
          vm.$onChanges = function (changes) {
            if (!changes.isFirstChange) {
              if (angular.isDefined(changes.clientmode) && angular.isDefined(changes.clientmode.currentValue)) {
                vm.clientmode = changes.clientmode.currentValue;
                if (vm.clientmode === 'patient') {
                  vm.kunde = 'Patient';
                  vm.kunden = 'Patienten';
                }
                else {
                  vm.kunde = 'Kunde';
                  vm.kunden = 'Kunden';
                }
              }
            }
          };


          // use aggregate query to obtain a list of distinct tags
          // first match all documents containing a tag that fits the regex
          // then unwind the document per tag to obtain multiple copies
          function getTags(val) {
            $log.debug('scansorter getTags query; ',val);
            // let myregex = '^' + val; // when using $regex, do not include '/' for regex delimiter
            let myregex = val; // when using $regex, do not include '/' for regex delimiter
            let match = [
              {$match: {flattags: {$regex: myregex, $options: 'i'}}},
              {$unwind: '$flattags'},
              {$match: {flattags: {$regex: myregex, $options: 'i'}}},
              {$group: {_id: '$flattags', total: {$sum: 1}}}];
            $log.debug('scansorter  Sending tags query');
            return $http.post('/routes/files/aggregate', match).then(function (response) {
              $log.debug('##### scansorter: tags received: ', response);
                let tags = new Set();
                if (angular.isDefined(response) && angular.isDefined(response.data) && response.data.length > 0) {
                    // create set to group by value
                    tags = new Set(response.data.map(function (tag) {
                        return tag._id;
                    }));
                    $log.debug('scansorter: tags set from array result: ', tags);
                }
                else if (angular.isDefined(response) && angular.isDefined(response.data) && angular.isDefined(response.data._id)) {
                    tags = new Set([response.data._id]);
                    $log.debug('scansorter: tags set from single result: ', tags);

                }
                // return array because ngTagsLib expects an array not a set
                $log.debug('scnasorter: array for ngTagsLib : ', Array.from(tags));
                return Array.from(tags);
            });
          }


          function saveClient(client, mode) {
            $log.debug('scansorter saveClient called with: ', client, mode);
            if (mode === 'patient') {
              vm.file.patientid = client._id;
              vm.file.patientfname = client.primarycontact.firstname + ' ' + client.primarycontact.lastname + ', ' + client.svdata.svnr;
            }
            else {
              vm.file.clientid = client._id;
              vm.file.clientfname = client.primarycontact.firstname + ' ' + client.primarycontact.lastname;
            }

            ClientHelper.find(mode, client._id).$then(function (lclient) {
              vm.client = lclient;
            });

            $log.debug('scansorter saveClient assigned fname: ', vm.file.patientfname, vm.file.clientfname );


            vm.save(false);
          }

          function diagClientSave() {
            if (vm.client.$hasPendingActions()) {
              vm.client.$cancel();
            }
            vm.client.$save().$then(() => {
            }, (error) => {
              $log.error('vcdms scansorter failed to save client (diagnoses): ', error);
              Rlog.error('vcdms', 'scansorter', 'failed to save client (diagnoses)', {
                clientid: vm.client._id,
                mode: vm.clientmode
              });
            });
          }

          function assignCat(cat) {
            switch (cat) {
              case 'generic':
                if (vm.clientmode === 'patient') {
                  clearPatient();
                } else {
                  clearClient();
                }
                break;
              case 'patient':
                break;
              default:
                break;
            }
            vm.file.doccat = cat;
            vm.save(false);
          }

          function finish() {
            switch (vm.file.doccat) {
              case 'generic':
                vm.file.scanstatus = 'finished';
                break;
              case 'patient':
                vm.file.scanstatus = 'assigned';
                break;
              default:
                break;
            }
            save(true);
          }


          function finishSignoff() {
            vm.file.scanstatus = 'finished';
            vm.file.signatureuser = $cookies.get('username');
            save(true);
          }


          function saveKeywords() {
            $log.debug('scansort save keywords: ', vm.file.keywords);
            let flattags = [];
            if (angular.isArray(vm.file.keywords)) {
              for (let i = 0; i < vm.file.keywords.length; i++) {
                flattags.push(vm.file.keywords[i].text);
              }
              vm.file.flattags = flattags;
              vm.save(false);
            }
          }


          function clearPatient() {
            delete vm.file.patientid;
            delete vm.file.patientfname;
            // delete vm.file.doccat;
            vm.file.scanstatus = 'captured';
            vm.save(false);
          }

          function clearClient() {
            delete vm.file.clientid;
            delete vm.file.clientfname;
            // delete vm.file.doccat;
            vm.file.scanstatus = 'captured';
            vm.save(false);
          }

          function formDisabled(scan) {
            let answer = true;
            if (angular.isObject(scan) && scan.hasOwnProperty('doccat') && scan.doccat === 'patient' && (angular.isString(scan.patientid) || angular.isString(scan.clientid))) {
              answer = false;
            }
            if (angular.isObject(scan) && scan.hasOwnProperty('doccat') && scan.doccat === 'generic') {
              answer = false;
            }
            return answer;
          }

          function formSignoffDisabled(scan) {
            let answer = true;

            if (angular.isObject(scan) && scan.hasOwnProperty('signature') && angular.isString(scan.signature) && scan.signature.length > 0) {
              answer = false;
            }
            return answer;
          }

          function save(lfinish) {
            $log.debug('saving file: ', vm.file);
            vm.parentsave({file: vm.file, finish: lfinish});
          }


          function addLog() {
            if (vm.clientmode === 'patient') {
              LogReminderHelper.addLog(vm.file.patientid, vm.clientmode);
            } else {
              LogReminderHelper.addLog(vm.file.clientid, vm.clientmode);
            }
          }

          function addReminder() {
            if (vm.clientmode === 'patient') {
              LogReminderHelper.addReminder(vm.file.patientid, vm.clientmode);
            } else {
              LogReminderHelper.addReminder(vm.file.clientid, vm.clientmode);
            }
          }


          // PDF Viewer Function wrappers
          function previousPage() {
            pdfDelegate.$getByHandle('scans-pdf-container').prev();
            vm.currentpage = pdfDelegate.$getByHandle('scans-pdf-container').getCurrentPage();
          }

          function nextPage() {
            pdfDelegate.$getByHandle('scans-pdf-container').next();
            vm.currentpage = pdfDelegate.$getByHandle('scans-pdf-container').getCurrentPage();
          }

          function zoomIn() {
            pdfDelegate.$getByHandle('scans-pdf-container').zoomIn();
          }

          function zoomOut() {
            pdfDelegate.$getByHandle('scans-pdf-container').zoomOut();
          }

          function rotatePage() {
            pdfDelegate.$getByHandle('scans-pdf-container').rotate();
          }

          function gotoPage() {
            if (vm.currentpage > 0 && vm.currentpage <= vm.maxpc) {
              pdfDelegate.$getByHandle('scans-pdf-container').goToPage(vm.currentpage);
            }
          }

        }

      ] // controller
    }); // component

// klammerfriedhof
}());
